
import { BiltyFormat3 } from "BiltyFomates";
import { getSupplerReportApi, getSupplerReportApi2 } from "_services";
import { CommonModal, CustomSelect } from "components";

import { API, AppConfig } from "lib";
import React, { useEffect, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import { Images } from "constants";
import { StorageServices } from "utils";


const SupplierReport = (props) => {
    const { supplier_id, start_date, end_date, closeModal } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false)
    let isToken = localStorage.getItem("token");
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
    const companyId = StorageServices.getCompanyId()

    useEffect(() => {
        if (companyId && supplier_id && end_date && start_date) {
            getSupplierTripapi()
        }
    }, [companyId, supplier_id, end_date, start_date])

    const getSupplierTripapi = async () => {
        setLoadingBilty(true)
        try {

            const res = await getSupplerReportApi2({
                company_id: StorageService?.getCompanyId(),
                supplier_id: supplier_id,
                start_date: start_date,
                end_date: end_date
            });

            setBuityFormatePreview(res)

            if (res?.responseCode == 404) {
                setLoadingBilty(false)
                 closeModal()
            } else {
                 setLoadingBilty(false)
            }

        } catch (error) {
        }
    };

    const handleDownload = async () => {
        try {
            const payload = {
                company_id: StorageService?.getCompanyId(),
                supplier_id: supplier_id,
                start_date: start_date,
                end_date: end_date
            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.SUPPLIER_REPORT_DOWNLOAD2}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Supplier-report/${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    }

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview
    };



    const propsBuiltyPrint = {
        ...props,
        // onSubmit:handlePrint
        // onPrint: handleDownload,
        onSubmit: handleDownload,
        isLoadding: isLoaddingPrint,
        disabled: isLoaddingPrint,
        isLoaddingPrint: isLoaddingPrint
    };



    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body" style={{ display: "block" }}>
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>
                </div>
            </CommonModal>


        </>
    );
};

export default SupplierReport;
